import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const LAST_UPDATED = 'July 22, 2026';

const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link 
              to="/" 
              className="text-2xl font-bold text-gray-900 hover:text-blue-600 transition-colors"
            >
              Andrea Villalobos
            </Link>
            <Link 
              to="/" 
              className="text-blue-600 hover:text-blue-800 transition-colors font-medium"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Disclaimer</h1>
          
          <div className="bg-red-50 border-l-4 border-red-400 p-6 mb-8">
            <p className="text-red-800 font-medium">
              <strong>Important:</strong> Please read this disclaimer carefully before using andreavillalobos.com
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. No Medical Advice</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The information provided on this Website is for informational and educational purposes only. It is not intended as medical advice, diagnosis, or treatment. The content on this Website, including but not limited to information about GLP-1 peptides, health journeys, and personal experiences, should not be considered as professional medical advice.
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Always consult with a qualified healthcare professional</strong> before making any decisions about your health, including starting any new medications, supplements, or treatment plans. Never disregard professional medical advice or delay in seeking it because of something you have read on this Website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. No Professional Relationship</h2>
            <p className="text-gray-700 leading-relaxed">
              The use of this Website does not create a professional relationship between you and Andrea Villalobos. Andrea Villalobos is not a licensed healthcare provider, physician, or medical professional. Any information shared is based on personal experience and should not be construed as professional medical advice.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Information Accuracy</h2>
            <p className="text-gray-700 leading-relaxed">
              While we strive to provide accurate and up-to-date information, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on this Website. Any reliance you place on such information is strictly at your own risk.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. External Links and Third-Party Services</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              This Website may contain links to external websites, including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Travel agency services</li>
              <li>Healthcare providers and medical services</li>
              <li>GLP-1 peptide and pharmaceutical companies</li>
              <li>Other business partners and affiliates</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              We have no control over the nature, content, and availability of these external sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them. We are not responsible for the content, privacy policies, or practices of any third-party websites or services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Affiliate and Marketing Disclosure</h2>
            <p className="text-gray-700 leading-relaxed">
              Andrea Villalobos may have business relationships with companies mentioned on this Website, including travel agencies and healthcare-related businesses. These relationships may include affiliate partnerships, referral programs, or other business arrangements. Any compensation received does not influence the content or opinions expressed on this Website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Personal Experiences and Testimonials</h2>
            <p className="text-gray-700 leading-relaxed">
              Any personal experiences, testimonials, or results shared on this Website are individual experiences and may not be representative of typical results. Individual results may vary significantly. Past performance or results do not guarantee future outcomes.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. No Guarantees or Warranties</h2>
            <p className="text-gray-700 leading-relaxed">
              This Website is provided on an "as is" and "as available" basis. We make no representations or warranties of any kind, express or implied, regarding the use or the results of this Website in terms of its correctness, accuracy, reliability, or otherwise. We shall have no liability for any interruptions in the use of this Website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              In no event shall Andrea Villalobos, her representatives, or any third parties mentioned on this Website be liable for any damages (including, without limitation, incidental and consequential damages, personal injury/wrongful death, lost profits, or damages resulting from lost data or business interruption) resulting from the use or inability to use this Website or the content, whether based on warranty, contract, tort, or any other legal theory, and whether or not we are advised of the possibility of such damages.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Emergency Situations</h2>
            <p className="text-gray-700 leading-relaxed">
              If you are experiencing a medical emergency, call your local emergency services immediately. This Website is not a substitute for emergency medical care.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have any questions about this disclaimer, please contact us at:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mt-4">
              <p className="text-gray-700">
                <strong>Andrea Villalobos</strong><br />
                Website: andreavillalobos.com<br />
                Email: [Contact information available through external links]
              </p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-8 mt-12">
            <p className="text-sm text-gray-500">
                Last updated: {LAST_UPDATED}
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12 mt-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">About</h3>
              <p className="text-sm">
                Andrea Villalobos: Your supportive guide for navigating GLP-1 peptides and prioritizing your health journey.
              </p>
            </div>
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
                <li><Link to="/main" className="hover:text-white transition-colors">Learn More</Link></li>
                <li><a href="mailto:..." className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            <div> 
              <h3 className="text-white text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link></li>
                <li><Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-center">
            <p>&copy; 2026 Andrea V. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Disclaimer;
